export const uncalculableFrequencies = ["HOUR", "LITER", "KW", "KWH"];
